import { Injectable, signal } from '@angular/core';

export type ToastType = 'success' | 'error' | 'warn' | 'info';

export interface Toast {
  id: string;
  message: string;
  type: ToastType;
  duration: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly _toasts = signal<Toast[]>([]);
  readonly toasts = this._toasts.asReadonly();

  show(message: string, type: ToastType = 'info', duration = 4500) {
    const id = crypto.randomUUID();
    this._toasts.update((ts) => [...ts, { id, message, type, duration }]);
    setTimeout(() => this.dismiss(id), duration);
  }

  success(message: string) {
    this.show(message, 'success', 4000);
  }
  error(message: string) {
    this.show(message, 'error', 6000);
  }
  warn(message: string) {
    this.show(message, 'warn', 5000);
  }
  info(message: string) {
    this.show(message, 'info', 4000);
  }

  dismiss(id: string) {
    this._toasts.update((ts) => ts.filter((t) => t.id !== id));
  }
}
